import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=f51fd470&scoped=true"
import script from "./officialAccount.vue?vue&type=script&lang=js"
export * from "./officialAccount.vue?vue&type=script&lang=js"
import style0 from "./officialAccount.vue?vue&type=style&index=0&id=f51fd470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51fd470",
  null
  
)

export default component.exports